<div class="modal-header modalHeaderBlack">
  <h6 class="modal-title">{{ "adt.accountDetails" | translate }}</h6>
  <span
    aria-label="Close"
    class="close"
    (click)="onClick()"
    data-automation-attribute="span-close-dialog"
  >
    <mat-icon matTooltip="{{ 'AddInternalNotes.close' | translate }}"
      >clear</mat-icon
    >
  </span>
</div>

<div class="divepisodeconversion">
  <div class="example-container">
    <table
      mat-table
      [dataSource]="dataSourceAccountDetails"
      class="height150 divFullWidth"
    >
      <ng-container matColumnDef="#">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">#</th>
        <td
          mat-cell
          class="col-norwap"
          *matCellDef="let element; let index = index"
        >
          {{ index + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerType">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">
          {{ "adt.payerType" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="headerDescription">
          {{ element.payerType ? element.payerType.display: "" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="payerName">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">
          {{ "billing.payerName" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="headerDescription">
          {{ element.payer ? element.payer.display : "" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="glStatus">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">
          {{ "adt.glStatus" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="headerDescription">
          {{ element.glType ? element.glType.display : "" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tariff">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">
          {{ "master.tariff" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="headerDescription">
          {{ element.tariff ? element.tariff.display : "" }}
        </td>
      </ng-container>
      
      <ng-container matColumnDef="contract">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">
          {{ "adt.contract" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="headerDescription">
          {{ element.contract ? element.contract.display : ""}}
        </td>
      </ng-container>

      <ng-container matColumnDef="glCoverageAmt">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">
          {{ "billing.coverage" | translate }}
        </th>
       
        <td mat-cell *matCellDef="let element" class="headerDescription center">
          {{ element ? (element.glCoverageAmt | number: '1.2-2') : '0.00' }}
        </td>
      </ng-container>
      <ng-container matColumnDef="remark">
        <th mat-header-cell *matHeaderCellDef class="headerDescription">
          {{ "EncounterPage.remark" | translate }}
        </th>
        <td mat-cell *matCellDef="let element" class="headerDescription">
          {{ element?.remark ? element.remark : "" }}
        </td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumnsAccountDetails; sticky: true"
        class="tableHeaderGreen"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumnsAccountDetails"
        class="tableRow"
      ></tr>
    </table>
  </div>
</div>
